import { render, staticRenderFns } from "./userWxInfo.vue?vue&type=template&id=66d7046d&scoped=true&"
import script from "./userWxInfo.vue?vue&type=script&lang=js&"
export * from "./userWxInfo.vue?vue&type=script&lang=js&"
import style0 from "./userWxInfo.vue?vue&type=style&index=0&id=66d7046d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d7046d",
  null
  
)

export default component.exports